var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8329_578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.66 7.99961L12 2.34961L6.34 7.99961C4.78 9.55961 4 11.6396 4 13.6396C4 15.6396 4.78 17.7496 6.34 19.3096C7.9 20.8696 9.95 21.6596 12 21.6596C14.05 21.6596 16.1 20.8696 17.66 19.3096C19.22 17.7496 20 15.6396 20 13.6396C20 11.6396 19.22 9.55961 17.66 7.99961ZM6 13.9996C6.01 11.9996 6.62 10.7296 7.76 9.59961L12 5.26961L16.24 9.64961C17.38 10.7696 17.99 11.9996 18 13.9996H6Z",
    fill: "#06D7F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8329_578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluids);
export default __webpack_public_path__ + "static/media/fluids.c5cd3a0838f2372116cb97b03b337c84.svg";
export { ForwardRef as ReactComponent };